module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/id icon-e12970e7.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/id icon.svg
// module id = ./app/web/src/assets/id icon.svg
// module chunks = 0